let zineData = [];

zineData = [
        {
            title: "How to Make Zine Article",
            description: "An article with pictures of how to fold your 8-page zine!",
            link: "https://www.readbrightly.com/how-to-make-zine/"
        },
        {
            title: "How to Make Zine Video",
            description: "A step-by-step video walkthrough of how to fold your 8-page zine!",
            link: "https://www.youtube.com/shorts/2LDyKQLEMtwhttps://www.google.com/"
        }
    ]


export default zineData;
